import React from 'react';

import { CategoriesView } from './view';

export const Categories = () => (<CategoriesView />);